module.exports = __webpack_public_path__ + "static/media/logoOld.f5ba94df.svg";